import { useState, useCallback, useContext } from 'react';
import styled from 'styled-components';
import ThumbDownFilledIconBase from '@mui/icons-material/ThumbDownAltRounded';
import ThumbDownIconBase from '@mui/icons-material/ThumbDownOffAltRounded';
import { Tooltip } from '@mui/material';
import { TrackingContext } from '../../providers/tracking';
import { Flex } from '../Flex';
import IconButton from '../IconButton';

const ThumbDownIcon = styled(ThumbDownIconBase)`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.common.black};
`;

const ThumbUpIcon = styled(ThumbDownIcon)`
  transform: rotate(180deg);
`;

const ThumbDownFilledIcon = styled(ThumbDownFilledIconBase)`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.common.black};
`;

const ThumbUpFilledIcon = styled(ThumbDownFilledIcon)`
  transform: rotate(180deg);
`;

type Props = {
  message: string;
  eventType: string;
};

const FeedbackButtons = ({ message, eventType }: Props) => {
  const tracking = useContext(TrackingContext);
  const trackingEvents = tracking?.analytics.events;
  const [selectedFeedback, setSelectedFeedback] = useState<
    'like' | 'dislike' | undefined
  >();

  const handleTracking = useCallback(
    async (
      status: 'like' | 'dislike' | 'undo-like' | 'undo-dislike',
      trackingEventType: string,
      value: string = '',
    ) => {
      tracking?.sendTrackingEvent({
        eventName: trackingEvents?.[trackingEventType],
        properties: { value, status },
      });
    },
    [tracking, trackingEvents],
  );

  const handleFeedback = (status: 'like' | 'dislike', value: string) => {
    if (status === selectedFeedback) {
      setSelectedFeedback(undefined);
      handleTracking?.(status === 'like' ? 'undo-like' : 'undo-dislike', value);
    } else {
      setSelectedFeedback(status);
      handleTracking?.(status, eventType, value);
    }
  };

  return (
    <Flex justifyContent="flex-start">
      <Tooltip title="I like this">
        <IconButton
          onClick={() => handleFeedback('like', message)}
          size="small"
        >
          {selectedFeedback === 'like' ? (
            <ThumbUpFilledIcon />
          ) : (
            <ThumbUpIcon />
          )}
        </IconButton>
      </Tooltip>

      <Tooltip title="Wasn't helpful enough">
        <IconButton
          onClick={() => handleFeedback('dislike', message)}
          size="small"
        >
          {selectedFeedback === 'dislike' ? (
            <ThumbDownFilledIcon />
          ) : (
            <ThumbDownIcon />
          )}
        </IconButton>
      </Tooltip>
    </Flex>
  );
};

export default FeedbackButtons;
